import styled from "styled-components";

const StyledDropdownToggle = styled.div`
  display: block;
`;

export default StyledDropdownToggle;
